import { render, staticRenderFns } from "./AppStatement.vue?vue&type=template&id=49139a3a&scoped=true&"
import script from "./AppStatement.vue?vue&type=script&lang=ts&"
export * from "./AppStatement.vue?vue&type=script&lang=ts&"
import style0 from "./AppStatement.vue?vue&type=style&index=0&id=49139a3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49139a3a",
  null
  
)

export default component.exports